import axios from 'axios';

const { loginRootUrl, additionalHeaders } = window.appAirDrop.config;

export function getConsentPoliciesFromAirdrop(config: any) {
  return config.consentPolicies;
}
export function getConsentPoliciesFromAirdropByName(config: any, name: string) {
  const policy = config?.consentPolicies?.find((n: any) => n.category === name);
  return policy ? policy.url : null;
}

export async function doAcceptConsentsAndLogin(signinData: any) {
  const path = `${loginRootUrl}/login/webacceptconsent`;
  const response = await axios.post(
    path,
    new URLSearchParams(signinData).toString(),
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    },
  );

  return response;
}
